// extracted by mini-css-extract-plugin
module.exports = {"grid":"SimilarVehiclesVehiclesGrid_grid__s4HVM","item":"SimilarVehiclesVehiclesGrid_item__ZOtmB"};